export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: 'korean' | 'japanese' | 'chinese' | 'series';
  tags: string[];
  description: string;
  longDescription: string;
  rating: number;
  views: number;
  chapters: number;
  status: 'ongoing' | 'completed';
  updatedAt: string;
  chaptersList: ComicChapter[];
}

export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'korean',
    name: '韩漫',
    description: '精选韩国人气漫画，画风精美剧情扣人心弦',
    icon: 'ri-chat-smile-3-fill',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%20with%20romantic%20couple%20characters%20in%20modern%20Seoul%20cityscape%2C%20soft%20pastel%20colors%2C%20clean%20digital%20art%20style%2C%20warm%20lighting%2C%20vertical%20composition%2C%20artistic%20and%20atmospheric&width=600&height=400&seq=cat-korean-01&orientation=landscape',
    count: 48,
  },
  {
    id: 'cat-2',
    slug: 'japanese',
    name: '日漫',
    description: '经典日本漫画，热血冒险与治愈日常一网打尽',
    icon: 'ri-sun-fill',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20featuring%20dynamic%20action%20pose%20characters%20with%20vibrant%20cherry%20blossom%20background%2C%20clean%20line%20art%20digital%20illustration%2C%20warm%20soft%20colors%2C%20anime%20aesthetic%20composition&width=600&height=400&seq=cat-japanese-01&orientation=landscape',
    count: 65,
  },
  {
    id: 'cat-3',
    slug: 'chinese',
    name: '国漫',
    description: '国产优质漫画，仙侠玄幻都市题材丰富多彩',
    icon: 'ri-fire-fill',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20martial%20arts%20characters%20in%20traditional%20hanfu%20clothing%2C%20ancient%20Chinese%20palace%20architecture%20background%2C%20ink%20wash%20painting%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20elegant%20digital%20art&width=600&height=400&seq=cat-chinese-01&orientation=landscape',
    count: 52,
  },
  {
    id: 'cat-4',
    slug: 'series',
    name: '系列漫画',
    description: '热门系列合集，一口气追完精彩故事',
    icon: 'ri-stack-fill',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20colorful%20comic%20book%20covers%20arranged%20in%20grid%20pattern%2C%20vibrant%20illustration%20style%2C%20clean%20modern%20display%2C%20warm%20ambient%20lighting%2C%20organized%20bookshelf%20aesthetic%2C%20digital%20art%20showcase&width=600&height=400&seq=cat-series-01&orientation=landscape',
    count: 36,
  },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    slug: 'secretarys-secret',
    title: '社内相亲',
    author: 'HAEBI / PANGIN',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20featuring%20elegant%20office%20woman%20and%20handsome%20CEO%20in%20modern%20city%20setting%2C%20soft%20romantic%20mood%2C%20professional%20illustration%20style%2C%20warm%20pink%20and%20gold%20accents%2C%20clean%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'korean',
    tags: ['恋爱', '职场', '都市'],
    description: '平凡上班族意外卷入与完美上司的秘密恋情，办公室里的心跳加速故事。',
    longDescription: '金智秀是一家大型企业的普通职员，某天意外被卷入了一场"假扮相亲对象"的计划中。而她的相亲对象，竟然是公司里最令人敬畏的执行总监——那个完美到不真实的男人。原本只是一场被迫的相亲，却在一次次接触中，两颗心慢慢靠近。办公室里的秘密恋情，从此开始了一段令人心跳加速的故事。画风精致，剧情甜中带虐，是不可错过的韩漫佳作。',
    rating: 9.6,
    views: 2345678,
    chapters: 86,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chaptersList: [
      { id: 'ch-1-86', title: '第86话 - 最后的告白', number: 86, updatedAt: '2026-08-03' },
      { id: 'ch-1-85', title: '第85话 - 意外的访客', number: 85, updatedAt: '2026-07-27' },
      { id: 'ch-1-84', title: '第84话 - 雨中的约定', number: 84, updatedAt: '2026-07-20' },
      { id: 'ch-1-83', title: '第83话 - 家族晚餐', number: 83, updatedAt: '2026-07-13' },
      { id: 'ch-1-82', title: '第82话 - 无法说出口的话', number: 82, updatedAt: '2026-07-06' },
    ],
  },
  {
    id: 'comic-2',
    slug: 'demon-slayer-requiem',
    title: '鬼灭之刃外传：镇魂歌',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20action%20cover%20art%20with%20samurai%20demon%20slayer%20character%20holding%20katana%20sword%2C%20dramatic%20dynamic%20pose%2C%20dark%20mysterious%20background%20with%20flame%20effects%2C%20intense%20illustration%20style%2C%20cool%20blue%20and%20red%20contrast&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'japanese',
    tags: ['热血', '冒险', '战斗'],
    description: '延续鬼灭之刃世界观的精彩外传，新角色登场揭开不为人知的战役。',
    longDescription: '在鬼杀队与无惨的最终决战之后，世界恢复了和平。然而，在遥远的北方之地，新的威胁正在悄然苏醒。一位继承了日之呼吸的少年，踏上了寻找真相的旅途。本作延续了鬼灭之刃独特的世界观与精美画风，讲述了一个关于勇气、友情与牺牲的全新故事。新老角色交织，热血战斗场面令人热血沸腾。',
    rating: 9.4,
    views: 1890234,
    chapters: 42,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chaptersList: [
      { id: 'ch-2-42', title: '第42话 - 觉醒', number: 42, updatedAt: '2026-08-02' },
      { id: 'ch-2-41', title: '第41话 - 绝境', number: 41, updatedAt: '2026-07-26' },
      { id: 'ch-2-40', title: '第40话 - 援军', number: 40, updatedAt: '2026-07-19' },
      { id: 'ch-2-39', title: '第39话 - 血战', number: 39, updatedAt: '2026-07-12' },
    ],
  },
  {
    id: 'comic-3',
    slug: 'celestial-realm',
    title: '仙王的日常生活',
    author: '枯玄',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20xianxia%20cover%20art%20featuring%20immortal%20cultivator%20in%20flowing%20white%20robes%20surrounded%20by%20floating%20spiritual%20energy%2C%20ancient%20Chinese%20mountain%20landscape%2C%20ethereal%20atmosphere%2C%20ink%20painting%20style%20blend%20with%20modern%20digital%20art&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'chinese',
    tags: ['修仙', '搞笑', '日常'],
    description: '修真界第一强者想过平凡生活，却总是被各种意外打破宁静。',
    longDescription: '王令，六岁就修成真仙的天才，如今是一名普通的高中生。他最大的愿望就是过上平静的校园生活，然而作为修真界公认的最强者，麻烦总是自动找上门来。从天降美少女到异界来客，从妖怪袭击到世界危机，王令的"平凡"日常永远充满惊喜。轻松搞笑的修仙日常，让你在欢笑中感受不一样的修真世界。',
    rating: 9.3,
    views: 1567890,
    chapters: 210,
    status: 'ongoing',
    updatedAt: '2026-08-01',
    chaptersList: [
      { id: 'ch-3-210', title: '第210话 - 期末考试', number: 210, updatedAt: '2026-08-01' },
      { id: 'ch-3-209', title: '第209话 - 新来的转校生', number: 209, updatedAt: '2026-07-25' },
      { id: 'ch-3-208', title: '第208话 - 灵气复苏', number: 208, updatedAt: '2026-07-18' },
    ],
  },
  {
    id: 'comic-4',
    slug: 'sweet-home-aftermath',
    title: '甜蜜家园：余波',
    author: '金坎比 / 黄英璨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20with%20apocalyptic%20survival%20theme%2C%20group%20of%20survivors%20in%20dark%20corridor%2C%20tense%20atmosphere%2C%20dramatic%20lighting%20from%20flashlight%2C%20detailed%20character%20expressions%2C%20gritty%20realistic%20illustration%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'korean',
    tags: ['惊悚', '末日', '生存'],
    description: '甜蜜家园世界观续作，幸存者们在新世界中寻找希望。',
    longDescription: '在"甜蜜家园"事件之后，世界已经彻底改变。怪物化现象仍在蔓延，幸存的人类在废墟中挣扎求生。曾经是高中生的车贤秀，如今成为了幸存者群体的核心人物。面对更加凶残的新型怪物和人性的黑暗面，他必须做出艰难的抉择。金坎比与黄英璨再次联手，带来更加震撼的末日生存故事，探讨人性在极端环境下的挣扎与光辉。',
    rating: 9.5,
    views: 1987654,
    chapters: 34,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chaptersList: [
      { id: 'ch-4-34', title: '第34话 - 信号', number: 34, updatedAt: '2026-08-03' },
      { id: 'ch-4-33', title: '第33话 - 地下基地', number: 33, updatedAt: '2026-07-27' },
      { id: 'ch-4-32', title: '第32话 - 背叛', number: 32, updatedAt: '2026-07-20' },
      { id: 'ch-4-31', title: '第31话 - 新盟友', number: 31, updatedAt: '2026-07-13' },
    ],
  },
  {
    id: 'comic-5',
    slug: 'spy-family-continues',
    title: '间谍过家家 第二季',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20comedy%20manga%20cover%20with%20family%20of%20three%20spy%20assassin%20and%20telepath%20girl%20in%20elegant%20evening%20attire%2C%20playful%20expressions%2C%20warm%20family%20atmosphere%2C%20clean%20anime%20illustration%20style%2C%20soft%20pastel%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'japanese',
    tags: ['搞笑', '家庭', '间谍'],
    description: '福杰一家的温馨日常继续上演，更多爆笑与感动交织的故事。',
    longDescription: '劳埃德·福杰，代号"黄昏"的西国顶级间谍。约尔·福杰，代号"睡美人"的致命杀手。阿尼亚·福杰，能读心的超能力少女。这个由谎言拼凑而成的家庭，在第二季中将面临更多的挑战与温馨时刻。从学校活动到国际危机，福杰一家用独特的方式守护着彼此与世界和平。远藤达哉以细腻的笔触描绘出令人捧腹又感动落泪的家庭喜剧。',
    rating: 9.7,
    views: 2678901,
    chapters: 28,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chaptersList: [
      { id: 'ch-5-28', title: '第28话 - 伊甸学园祭', number: 28, updatedAt: '2026-08-02' },
      { id: 'ch-5-27', title: '第27话 - 邦德的秘密', number: 27, updatedAt: '2026-07-26' },
      { id: 'ch-5-26', title: '第26话 - 家庭旅行', number: 26, updatedAt: '2026-07-19' },
    ],
  },
  {
    id: 'comic-6',
    slug: 'battle-through-heavens-remake',
    title: '斗破苍穹·重制版',
    author: '天蚕土豆 / 任翔',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20with%20young%20warrior%20wielding%20flame%20sword%20in%20epic%20battle%20stance%2C%20giant%20dragon%20silhouette%20in%20background%2C%20dramatic%20fiery%20atmosphere%2C%20dynamic%20action%20illustration%20style%2C%20vibrant%20orange%20and%20gold%20color%20scheme&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'chinese',
    tags: ['玄幻', '热血', '冒险'],
    description: '经典国漫重制归来，萧炎的成长之路以全新画质呈现。',
    longDescription: '天才少年萧炎在创造了家族空前的修炼纪录后，突然变成了废人。种种打击接踵而至，就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现。一扇全新的大门向他开启！重制版以更加精美的画风和更流畅的分镜，重新演绎这部经典国漫的传奇故事。无论是老粉丝还是新读者，都能在这场视觉盛宴中感受斗气大陆的魅力。',
    rating: 9.5,
    views: 3456789,
    chapters: 156,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chaptersList: [
      { id: 'ch-6-156', title: '第156话 - 强者之心', number: 156, updatedAt: '2026-08-03' },
      { id: 'ch-6-155', title: '第155话 - 决战前夕', number: 155, updatedAt: '2026-07-27' },
      { id: 'ch-6-154', title: '第154话 - 丹塔试炼', number: 154, updatedAt: '2026-07-20' },
    ],
  },
  {
    id: 'comic-7',
    slug: 'tower-of-god-season3',
    title: '神之塔 第三季',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20with%20mysterious%20tower%20rising%20into%20sky%2C%20diverse%20cast%20of%20characters%20climbing%2C%20magical%20ethereal%20atmosphere%2C%20intricate%20world%20building%20illustration%2C%20deep%20blue%20and%20purple%20cosmic%20tones%2C%20vertical%20scroll%20format%20aesthetic&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'korean',
    tags: ['奇幻', '冒险', '战斗'],
    description: '夜的旅程继续，塔的更高层隐藏着更加惊人的秘密。',
    longDescription: '二十五夜进入了神之塔的更高层级，这里的规则更加残酷，敌人更加强大。随着吉黑德公主和十大家族势力的介入，塔内的权力斗争愈发激烈。夜能否找到真正的拉结尔？塔的顶端到底隐藏着什么？SIU以其宏大的世界观构建和精彩的人物刻画，继续书写这一史诗级冒险的第三季。每一层塔都是一次全新的挑战与成长。',
    rating: 9.6,
    views: 2123456,
    chapters: 68,
    status: 'ongoing',
    updatedAt: '2026-08-01',
    chaptersList: [
      { id: 'ch-7-68', title: '第68话 - 管理者之试炼', number: 68, updatedAt: '2026-08-01' },
      { id: 'ch-7-67', title: '第67话 - 凯撒的阴谋', number: 67, updatedAt: '2026-07-25' },
      { id: 'ch-7-66', title: '第66话 - 意外的盟友', number: 66, updatedAt: '2026-07-18' },
    ],
  },
  {
    id: 'comic-8',
    slug: 'one-piece-final-saga',
    title: '海贼王·最终章',
    author: '尾田荣一郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20pirate%20adventure%20manga%20cover%20with%20straw%20hat%20crew%20sailing%20on%20grand%20ship%20toward%20sunset%20horizon%2C%20epic%20adventure%20atmosphere%2C%20dynamic%20group%20composition%2C%20classic%20shonen%20illustration%20style%2C%20warm%20golden%20hour%20lighting&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'japanese',
    tags: ['热血', '冒险', '友情'],
    description: '路飞一伙驶向最终之岛，二十余年的传奇即将迎来高潮。',
    longDescription: '经过二十余年的连载，草帽一伙终于驶入了伟大航路的最终海域。古代兵器的秘密、空白一百年的真相、ONE PIECE的真正含义——所有的谜团都将在这里揭晓。路飞与他的伙伴们将面对有史以来最强大的敌人，海军、四皇、世界政府的终极对决一触即发。尾田荣一郎倾注全部心血，为这部史诗巨作画上最震撼的句号。',
    rating: 9.8,
    views: 4567890,
    chapters: 1123,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chaptersList: [
      { id: 'ch-8-1123', title: '第1123话 - 黎明之前', number: 1123, updatedAt: '2026-08-02' },
      { id: 'ch-8-1122', title: '第1122话 - 四皇集结', number: 1122, updatedAt: '2026-07-26' },
      { id: 'ch-8-1121', title: '第1121话 - 古代兵器觉醒', number: 1121, updatedAt: '2026-07-19' },
    ],
  },
  {
    id: 'comic-9',
    slug: 'my-id-is-gangnam-beauty-2',
    title: '我的ID是江南美人 第二季',
    author: '淇萌琪',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20campus%20romance%20manhwa%20cover%20with%20beautiful%20university%20student%20couple%20on%20campus%20with%20cherry%20blossoms%2C%20sweet%20romantic%20atmosphere%2C%20soft%20pastel%20pink%20tones%2C%20clean%20modern%20webtoon%20art%20style%2C%20spring%20season%20vibe&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'korean',
    tags: ['恋爱', '校园', '成长'],
    description: '整形后的美来步入职场，面对新的挑战与感情抉择。',
    longDescription: '姜美来通过整形手术获得了"江南美人"的称号，大学毕业后步入职场。然而新的环境带来了新的挑战——职场的外貌歧视、复杂的人际关系、以及对自我价值的重新审视。都炅锡始终陪伴在她身边，但两人的感情也面临着来自家庭和社会的压力。淇萌琪以真实细腻的笔触，继续探讨外貌与自我认同这个深刻主题。',
    rating: 9.2,
    views: 1234567,
    chapters: 45,
    status: 'completed',
    updatedAt: '2026-07-15',
    chaptersList: [
      { id: 'ch-9-45', title: '第45话 - 新的开始', number: 45, updatedAt: '2026-07-15' },
      { id: 'ch-9-44', title: '第44话 - 求婚', number: 44, updatedAt: '2026-07-08' },
      { id: 'ch-9-43', title: '第43话 - 家人', number: 43, updatedAt: '2026-07-01' },
    ],
  },
  {
    id: 'comic-10',
    slug: 'under-one-person-season5',
    title: '一人之下 第五季',
    author: '米二',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20cover%20with%20modern%20martial%20artist%20using%20qi%20energy%20power%20in%20urban%20setting%2C%20dynamic%20action%20pose%2C%20mystical%20glowing%20effects%2C%20fusion%20of%20traditional%20and%20contemporary%20style%2C%20intense%20dramatic%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'chinese',
    tags: ['异能', '热血', '都市'],
    description: '异人世界的大战一触即发，张楚岚的真实身份即将揭晓。',
    longDescription: '随着甲申之乱真相的逐步揭开，张楚岚发现自己身上的秘密远比想象中更加复杂。全性、公司、十佬会谈——各大势力围绕八奇技展开了最后的争夺。冯宝宝的身世之谜、无根生的真正目的、以及张楚岚体内那股神秘力量的来源——所有的线索都指向了一个惊天的真相。米二以其独特的叙事风格，将传统文化与现代异能战斗完美融合。',
    rating: 9.4,
    views: 1876543,
    chapters: 95,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chaptersList: [
      { id: 'ch-10-95', title: '第95话 - 觉醒', number: 95, updatedAt: '2026-08-03' },
      { id: 'ch-10-94', title: '第94话 - 天师度', number: 94, updatedAt: '2026-07-27' },
      { id: 'ch-10-93', title: '第93话 - 罗天大醮终局', number: 93, updatedAt: '2026-07-20' },
    ],
  },
  {
    id: 'comic-11',
    slug: 'jujutsu-kaisen-shibuya-after',
    title: '咒术回战·涩谷之后',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%20with%20sorcerer%20character%20casting%20cursed%20energy%20spell%2C%20ominous%20black%20and%20white%20contrast%2C%20supernatural%20horror%20atmosphere%2C%20intricate%20line%20work%2C%20intense%20dramatic%20composition%2C%20gritty%20texture%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'japanese',
    tags: ['战斗', '黑暗', '奇幻'],
    description: '涩谷事件后的世界陷入混乱，咒术师们面临前所未有的危机。',
    longDescription: '涩谷事件的余波席卷了整个咒术界。五条悟被封印，大量咒术师牺牲，咒灵们变得更加猖獗。虎杖悠仁背负着巨大的罪责感继续前行，而羂索的千年计划正在一步步实现。在这个咒术界最黑暗的时刻，新一代的咒术师们必须成长起来。芥见下下以其标志性的凌厉画风和出人意料的剧情转折，将故事推向更加激烈的高潮。',
    rating: 9.3,
    views: 2098765,
    chapters: 48,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chaptersList: [
      { id: 'ch-11-48', title: '第48话 - 死灭回游·终', number: 48, updatedAt: '2026-08-02' },
      { id: 'ch-11-47', title: '第47话 - 天使的审判', number: 47, updatedAt: '2026-07-26' },
      { id: 'ch-11-46', title: '第46话 - 领域展开', number: 46, updatedAt: '2026-07-19' },
    ],
  },
  {
    id: 'comic-12',
    slug: 'legend-of-mortal-cultivation',
    title: '凡人修仙传',
    author: '忘语',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20of%20humble%20mortal%20ascending%20to%20immortality%20on%20misty%20mountain%20peak%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%20blended%20with%20digital%20art%2C%20serene%20yet%20powerful%20atmosphere%2C%20flowing%20robes%20and%20flying%20swords&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'chinese',
    tags: ['修仙', '凡人流', '长篇'],
    description: '一个普通山村少年韩立，凭借坚韧意志踏上修仙之路。',
    longDescription: '韩立，一个出身平凡的少年，因为一次偶然的机会踏入了修真世界。没有逆天的天赋，没有强大的背景，他凭借着过人的谨慎和坚韧的意志，在尔虞我诈的修真界中一步步向上攀登。从黄枫谷的外门弟子到人界第一修士，从灵界飞升到仙界争锋——这是一个关于凡人如何在残酷世界中生存并崛起的故事。忘语开创的"凡人流"修仙小说改编漫画，以朴实无华的画风讲述一个朴实无华的传奇。',
    rating: 9.5,
    views: 2876543,
    chapters: 320,
    status: 'ongoing',
    updatedAt: '2026-08-01',
    chaptersList: [
      { id: 'ch-12-320', title: '第320话 - 大乘渡劫', number: 320, updatedAt: '2026-08-01' },
      { id: 'ch-12-319', title: '第319话 - 仙宫遗迹', number: 319, updatedAt: '2026-07-25' },
      { id: 'ch-12-318', title: '第318话 - 古魔现世', number: 318, updatedAt: '2026-07-18' },
    ],
  },
  {
    id: 'comic-13',
    slug: 'true-beauty-season2',
    title: '女神降临 第二季',
    author: '喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20beauty%20makeup%20romance%20manhwa%20cover%20with%20glamorous%20young%20woman%20holding%20makeup%20brush%2C%20luxurious%20vanity%20mirror%20setting%2C%20sparkling%20elegant%20atmosphere%2C%20soft%20glamour%20lighting%2C%20beautiful%20detailed%20illustration%20style%2C%20feminine%20chic%20aesthetic&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    category: 'korean',
    tags: ['美妆', '恋爱', '校园'],
    description: '化妆变身女神的女主角，在爱情与自我认同之间寻找平衡。',
    longDescription: '任朱静通过精湛的化妆技术从"丑小鸭"变成了校园女神，但她的内心始终活在素颜被揭穿的恐惧中。第二季中，朱静逐渐学会接受真实的自己，同时在两个完美的男生——高冷学霸李修豪和阳光暖男韩书俊之间做出选择。喵喵以华丽细腻的画风和对美妆的热爱，创作出这部风靡亚洲的漫画。这不仅是一个关于爱情的故事，更是一个关于自我接纳与成长的温暖篇章。',
    rating: 9.1,
    views: 1789654,
    chapters: 60,
    status: 'completed',
    updatedAt: '2026-06-30',
    chaptersList: [
      { id: 'ch-13-60', title: '第60话 - 真正的女神', number: 60, updatedAt: '2026-06-30' },
      { id: 'ch-13-59', title: '第59话 - 选择', number: 59, updatedAt: '2026-06-23' },
      { id: 'ch-13-58', title: '第58话 - 素颜', number: 58, updatedAt: '2026-06-16' },
    ],
  },
  {
    id: 'comic-14',
    slug: 'chainsaw-man-part3',
    title: '电锯人 第三部',
    author: '藤本树',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20action%20manga%20cover%20with%20chainsaw%20wielding%20antihero%20character%20in%20urban%20chaos%2C%20punk%20gritty%20aesthetic%2C%20blood%20splatter%20artistic%20style%2C%20neon%20city%20night%20backdrop%2C%20raw%20aggressive%20energy%2C%20unique%20artistic%20illustration&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    category: 'japanese',
    tags: ['暗黑', '动作', '都市'],
    description: '电次的新生活刚刚开始，更强大的恶魔势力就找上了门。',
    longDescription: '经历了与玛奇玛的惨烈战斗后，电次终于过上了自己梦想中的"普通生活"。然而，身为电锯人的他注定无法平凡。新的恶魔猎人组织、神秘的预言中的"末日恶魔"、以及来自地狱最深处的古老存在——所有的线索都指向一场足以毁灭世界的危机。藤本树继续以他疯狂而天才的想象力，在这个荒诞又真实的世界中探索人性的边界。',
    rating: 9.6,
    views: 3124567,
    chapters: 36,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chaptersList: [
      { id: 'ch-14-36', title: '第36话 - 末日预言', number: 36, updatedAt: '2026-08-03' },
      { id: 'ch-14-35', title: '第35话 - 新生恶魔猎人', number: 35, updatedAt: '2026-07-27' },
      { id: 'ch-14-34', title: '第34话 - 那由多的秘密', number: 34, updatedAt: '2026-07-20' },
    ],
  },
  {
    id: 'comic-15',
    slug: 'the-begining-after-end',
    title: '三岁开始做王者',
    author: 'TurtleMe',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20reincarnation%20manhwa%20cover%20with%20young%20boy%20in%20royal%20attire%20surrounded%20by%20magical%20elements%2C%20medieval%20fantasy%20world%20setting%2C%20regal%20elegant%20atmosphere%2C%20warm%20golden%20magical%20aura%2C%20detailed%20character%20design%2C%20epic%20fantasy%20illustration&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    category: 'series',
    tags: ['转生', '奇幻', '冒险'],
    description: '最强王者格雷转生为婴儿，带着前世记忆重新征服世界。',
    longDescription: '格雷，曾经统治整个大陆的最强王者，在遭到背叛后神秘死亡。当他再次睁开眼睛时，发现自己变成了一个名为"亚瑟·雷温"的婴儿，重生在一个充满魔法与剑术的全新世界中。带着前世的记忆和战斗经验，亚瑟从三岁就开始了他的王者之路。这是一个关于第二次机会的故事——一个王者如何在新的世界中重新定义力量、友情与责任。',
    rating: 9.4,
    views: 1678901,
    chapters: 178,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chaptersList: [
      { id: 'ch-15-178', title: '第178话 - 龙族试炼', number: 178, updatedAt: '2026-08-02' },
      { id: 'ch-15-177', title: '第177话 - 导师的过去', number: 177, updatedAt: '2026-07-26' },
      { id: 'ch-15-176', title: '第176话 - 学院对抗赛', number: 176, updatedAt: '2026-07-19' },
    ],
  },
  {
    id: 'comic-16',
    slug: 'heaven-official-blessing',
    title: '天官赐福',
    author: '墨香铜臭 / STARember',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20danmei%20manhua%20cover%20with%20celestial%20god%20in%20flowing%20white%20and%20red%20robes%2C%20ethereal%20divine%20atmosphere%2C%20traditional%20Chinese%20architectural%20elements%2C%20delicate%20elegant%20art%20style%2C%20floating%20flower%20petals%2C%20soft%20dreamy%20lighting&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    category: 'chinese',
    tags: ['仙侠', '古风', '传奇'],
    description: '三界第一武神谢怜与鬼王花城跨越八百年的羁绊。',
    longDescription: '八百年前，谢怜是风光无限的仙乐太子。八百年后，他成了三界笑柄——飞升三次的破烂仙人。在他第三次被贬下凡时，遇到了一个神秘的红衣少年。这个少年似乎认识他很久了，而谢怜却对他一无所知。随着调查一系列诡异事件，一段跨越八百年的深情往事逐渐浮出水面。墨香铜臭笔下最动人的故事之一，由STARember以绝美画风呈现。',
    rating: 9.7,
    views: 2890123,
    chapters: 95,
    status: 'completed',
    updatedAt: '2026-05-20',
    chaptersList: [
      { id: 'ch-16-95', title: '第95话 - 千秋', number: 95, updatedAt: '2026-05-20' },
      { id: 'ch-16-94', title: '第94话 - 花灯', number: 94, updatedAt: '2026-05-13' },
      { id: 'ch-16-93', title: '第93话 - 铜炉山', number: 93, updatedAt: '2026-05-06' },
    ],
  },
];

export const featuredComicSlugs = [
  'secretarys-secret',
  'demon-slayer-requiem',
  'celestial-realm',
  'sweet-home-aftermath',
  'spy-family-continues',
  'battle-through-heavens-remake',
];

export const trendingComicSlugs = [
  'one-piece-final-saga',
  'chainsaw-man-part3',
  'tower-of-god-season3',
  'jujutsu-kaisen-shibuya-after',
  'heaven-official-blessing',
];

export function getComicsByCategory(categorySlug: string): Comic[] {
  return comics.filter((c) => c.category === categorySlug);
}

export function getComicBySlug(slug: string): Comic | undefined {
  return comics.find((c) => c.slug === slug);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}